<template>
  <div class="right_box_main">

    <div class="card-box">
      <div class="mapBox">
        <div
          id="mapacc"
          ref="mapdt"
        ></div>
      </div>
      <div class="listBox">
        <div
          class="listBox-item"
          style
        >
          <el-card>
            <el-row
              class="title-col"
              style="margin-bottom:10px;font-size:14px;"
              type="flex"
              justify="space-between"
            >
              <el-col>
                事件编号：
                <el-input
                  type="text"
                  size="mini"
                  v-model="searchlist.eventNumber"
                  style="width:130px;"
                  clearable
                  placeholder="事件编号"
                />&nbsp;&nbsp;
                上报时间：
                <el-date-picker
                  v-model="searchlist.createDate"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>&nbsp;&nbsp;
                <el-button
                  size="mini"
                  type="primary"
                  @click="searchlistdata"
                >查询</el-button>&nbsp;
                <el-button
                  size="mini"
                  type="info"
                  @click="searchlistReset"
                >重置</el-button>
              </el-col>
            </el-row>

            <el-row
              class="title-col"
              type="flex"
              justify="space-between"
              style="margin-bottom:3px;font-size:14px;"
            >
              <el-col>
                <el-tabs
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane
                    :label="'事件指派（'+showData.zp+'）'"
                    name="1"
                  ></el-tab-pane>
                  <el-tab-pane
                    :label="'回退审核（'+showData.ht+'）'"
                    name="7"
                  ></el-tab-pane>
                  <el-tab-pane
                    :label="'延期审核（'+showData.yq+'）'"
                    name="6"
                  ></el-tab-pane>
                  <el-tab-pane
                    :label="'作废审核（'+showData.zf+'）'"
                    name="8"
                  ></el-tab-pane>
                  <el-tab-pane
                    :label="'结案审核（'+showData.ja+'）'"
                    name="5"
                  ></el-tab-pane>
                  <!-- <el-tab-pane :label="'逾期事件（'+showData.overdue+'）'" name="9"></el-tab-pane> -->
                </el-tabs>
              </el-col>
            </el-row>
            <el-table
              ref="singleTable"
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              size="mini"
              border
              align="center"
              current-row-key
              highlight-current-row
              @current-change="eventNumberClick"
            >
              <!-- <el-table-column type="selection" align="center" width="50"></el-table-column> -->
              <el-table-column
                align="center"
                prop="eventNumber"
                width="160"
                label="事件编号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                width="130"
                label="处理单位"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="personName"
                width="100"
                label="处理人员"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="launch"
                width="100"
                label="上报人"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="eventSource"
                width="120"
                label="事件来源"
              ></el-table-column>
              <el-table-column
                prop="eventDescribe"
                width="300"
                label="事件描述"
              >
                <template slot-scope="scope">
                  <p
                    :title="scope.row.eventDescribe"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.eventDescribe}}</p>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="createDate"
                width="160"
                label="登记时间"
              ></el-table-column>
              <el-table-column
                align="center"
                width="120"
                prop="eventTypeName"
                label="大类名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="eventGroupName"
                width="150"
                label="小类名称"
              >
                <template slot-scope="scope">
                  <p
                    :title="scope.row.eventGroupName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.eventGroupName}}</p>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :formatter="formatter"
                prop="approvalStatus"
                label="事件状态"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="deadline"
                width="160"
                label="到期时间"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="createDate"
                width="100"
                label="是否逾期"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.overdue ==1?'是':'否'}}</span>
                </template>
              </el-table-column>
              <!--  -->
              <el-table-column
                align="center"
                label="操作"
                width="100"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    v-if="activeName=='1'"
                    class="item"
                    effect="light"
                    content="指派"
                    placement="top-start"
                    v-show="activeName == '1'"
                  >
                    <button
                      class="tabBtn el-icon-set-up tabBtn-edit"
                      @click="showDialog(scope.row,'point')"
                    ></button>
                  </el-tooltip>
                  <el-tooltip
                    v-if="activeName!='1'"
                    class="item"
                    effect="light"
                    content="审核"
                    placement="top-start"
                  >
                    <button
                      class="tabBtn el-icon-document-checked tabBtn-audit"
                      @click="showDialog(scope.row,'check')"
                    ></button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageConfig.pageNo"
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="pageConfig.total"
            ></el-pagination>
          </el-card>
        </div>
        <!-- 详情 -->
        <div
          class="listBox-item"
          id="detailBox"
          style="height:350px;overflow:hidden;"
        >
          <el-card>
            <el-row>
              <el-col style="width:250px;margin-top: 14px;">
                <el-image
                  style="width: 100%;"
                  :src="detail.eventFile1?detail.eventFile1[0]:''"
                  fit="cover"
                  :preview-src-list="detail.eventFile1?[detail.eventFile1[0]]:[]"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <p style="text-align:center">暂无封面图,请在附件信息查看</p>
                    <i
                      style="font-size:250px"
                      class="el-icon-picture-outline"
                    ></i>
                  </div>
                </el-image>
                <!-- <img
                                    style="width: 100%;"
                                    :src="detail.eventFile1?detail.eventFile1[0]:''"
                                    preview="index3"
                                />-->
                <!-- <img
                                    class="left-img"
                                    :src="detail.eventFile1[0]"
                                />-->
              </el-col>
              <el-col style="width:calc(100% - 250px);padding-left:30px;box-sizing: border-box;">
                <el-tabs v-model="detailActiveName">
                  <el-tab-pane
                    class="detailInfo"
                    label="详细信息"
                    name="first"
                  >
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">事件编号：{{detail.eventNumber}}</el-col>
                      <el-col :span="12">问题来源：{{detail.eventSource}}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">大类名称：{{detail.eventTypeName}}</el-col>
                      <el-col :span="12">小类名称：{{detail.eventGroupName }}</el-col>
                    </el-row>
                    <el-row>
                      事件问题描述：
                      <span style="line-height:20px;display: inline-block;">{{detail.eventDescribe}}</span>
                    </el-row>
                    <el-row>事件地址：{{detail.addressDetail}}</el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">事件状态：{{formatter(detail)}}</el-col>
                      <el-col :span="12">上报人：{{detail.launch}}</el-col>
                    </el-row>
                    <el-row>上报时间：{{detail.createDate}}</el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <!-- <el-col :span="12">事件处理时间：{{detail.handleTime}}</el-col> -->
                      <el-col :span="12">事件处理人：{{detail.personName}}</el-col>
                    </el-row>
                    <!-- <el-row>案件处理意见：{{detail.handleOpinion}}</el-row> -->
                    <el-row v-show="activeName == '7'">回退描述：{{detail.backReason}}</el-row>
                    <el-row v-show="activeName == '6'">
                      延期时间：{{detail.delayTime}}
                      <br />
                      延期描述：{{detail.delayReason}}
                    </el-row>
                    <el-row v-show="activeName == '8'">作废原因：{{detail.cancelReason}}</el-row>
                    <el-row v-show="activeName == '5'">结案描述：{{detail.completeReason}}</el-row>
                  </el-tab-pane>
                  <el-tab-pane
                    label="处理流程"
                    name="second"
                  >
                    <div
                      class="block"
                      style="padding:2px;"
                    >
                      <el-timeline>
                        <el-timeline-item
                          v-for="(item,index) in detail.logs"
                          :key="index"
                          :color="index==0?'#66b1ff':''"
                          :timestamp="item.createDate"
                          placement="top"
                        >
                          <el-card>
                            <h4>{{item.title}}</h4>
                            <p>{{item.content}}</p>
                            <p>备注：{{item.opinion?item.opinion:'无'}}</p>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane
                    label="附件信息"
                    name="third"
                  >
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <span class="demonstration">整改前</span>
                        <el-carousel
                          height="250px"
                          :autoplay="false"
                        >
                          <el-carousel-item
                            v-for="item in detail.eventFile1"
                            :key="item.id"
                          >
                            <img
                              v-show="item.substring(item.lastIndexOf('.')+1) == 'jpg' || item.substring(item.lastIndexOf('.')+1) =='png'"
                              preview="index"
                              style="width:100%"
                              :src="item"
                              alt
                            />
                            <video
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp4'"
                              :src="item"
                              controls="controls"
                            ></video>
                            <!-- <audio
                                                            type="audio/mpeg"
                                                            :src="item"
                                                            controls="controls"
                                                        ></audio>-->
                            <audio
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp3'"
                              controls
                            >
                              <source
                                :src="item"
                                type="audio/mpeg"
                              />
                            </audio>
                          </el-carousel-item>
                        </el-carousel>
                      </el-col>
                      <el-col :span="12">
                        <span class="demonstration">整改后</span>
                        <el-carousel
                          height="250px"
                          :autoplay="false"
                        >
                          <el-carousel-item
                            v-for="item in detail.eventFile2"
                            :key="item.id"
                          >
                            <!-- <el-image
                                                            style="width: 100%;height: 100%;"
                                                            :src="item"
                                                            fit="contain"
                                                            :preview-src-list="detail.eventFile1"
                                                        ></el-image>-->
                            <!-- {{item.substring(item.lastIndexOf('.')+1)}} -->
                            <img
                              v-show="item.substring(item.lastIndexOf('.')+1) == 'jpg' || item.substring(item.lastIndexOf('.')+1) =='png'"
                              preview="index2"
                              style="width:100%"
                              :src="item"
                              alt
                            />
                            <video
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp4'"
                              :src="item"
                              controls="controls"
                            ></video>
                            <!-- <audio
                                                            type="audio/mpeg"
                                                            :src="item"
                                                            controls="controls"
                                                        ></audio>-->
                            <audio
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp3'"
                              controls
                            >
                              <source
                                :src="item"
                                type="audio/mpeg"
                              />
                            </audio>
                          </el-carousel-item>
                        </el-carousel>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </div>

      <!-- 弹出框虚拟/作废/转派 -->
      <el-dialog
        class="newDialog"
        :title="funDialog.title"
        :visible.sync="funDialog.off"
        width="700px"
        center
        :before-close="clearaFunDialog"
      >
        <el-form
          size="mini"
          label-position="right"
          label-width="120px"
          :model="funDialog.form"
        >
          <el-form-item label="事件编号：">
            <el-input
              disabled
              v-model="funDialog.form.eventNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="funDialog.type!='point'"
            :label="funDialog.funName"
          >
            <el-input
              type="textarea"
              v-model="funDialog.form.info2"
              :rows="2"
              resize="none"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="延期时间："
            v-if="funDialog.form.delayTime"
          >
            <el-input
              disabled
              v-model="funDialog.form.delayTime"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="funDialog.type!='point'"
            label="审核结果："
          >
            <el-radio
              v-model="funDialog.form.off"
              label="true"
            >通过</el-radio>
            <el-radio
              v-model="funDialog.form.off"
              label="false"
            >不通过</el-radio>
            <!-- <el-select
                            size="mini"
                            v-model="funDialog.form.off"
                            placeholder="--结果--"
                            style="width:130px"
                        >
                            <el-option label="true" value="true">通过</el-option>
                            <el-option label="false" value="false">不通过</el-option>
                        </el-select>-->
          </el-form-item>
          <el-form-item
            v-if="funDialog.type!='point' && funDialog.form.off=='false'"
            label="审核原因"
          >
            <el-input
              type="textarea"
              v-model="funDialog.form.info"
              :rows="2"
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="处理单位:"
            v-show="funDialog.type=='point'"
          >
            <el-cascader
              ref="orgName"
              size="mini"
              v-model="funDialog.form.orgId"
              :options="orgTree"
              :show-all-levels="false"
              :props="{ checkStrictly: true }"
              placeholder="请选择所属网格"
              style="width:250px"
              clearable
              @change="getUser"
            ></el-cascader>
            <el-select
              v-model="funDialog.form.personId"
              placeholder="请选择人员"
              size="mini"
              ref="personName"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            size="small"
            style="margin: 0 30px"
            @click="funDialogClick"
          >确定</el-button>
          <el-button
            type="info"
            size="small"
            @click="clearaFunDialog"
          >取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const funMap = {}
import {
  updateProofOfEstablishment,
  examine,
  post,
} from "../../../api/requrestHttp.js"
import AMap from "AMap" // 引入高德地图
import request from "../../../utils/request.js"
let infoWindow
let map
let marker

export default {
  data() {
    return {
      searchlist: {
        createDate: [],
      },
      //事件状态
      statusMap: [],
      //事件来源
      sourceMap: [],
      //表格数据
      multipleSelection: [],
      tableData: [],
      pageConfig: {
        pageSize: 5,
        total: 0,
        pageNo: 1,
      },
      activeName: "1",
      detailActiveName: "first",
      funDialog: {
        form: {
          personId: "",
          off: "true",
          info: "",
          info2: "",
          delayTime: null,
        },
        off: false,
        title: "",
        type: "",
        funName: "",
      },
      detail: {
        isShow: false,
      },
      defaultImg: require("../../../assets/images/twoNetworkConvergence/ceshi1.png"),
      fileList: [],
      fileList_: "",
      //地图标记对象
      mapMarker: {
        lng: "117.49426",
        lat: "30.656587",
        title: "事件编码",
        extDataName: "事件编码",
        extDataDesc: "事件地址",
      },
      eventClickNum: 0,
      showData: {
        ht: 0,
        ja: 0,
        yq: 0,
        zf: 0,
        zp: 0,
      },
      selectOrgs: [],
      selectedOrgIds: [],
      permission: "sj:sjsl:zp",
      orgTree: [],
      userOptions: [],
    }
  },
  methods: {
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {
        createDate: [],
      }
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    async getPageDatas() {
      this.searchlist.approvalStatus = this.activeName
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      try {
        this.searchlist.startTime = this.searchlist.createDate[0]
          ? this.searchlist.createDate[0] + " 00:00:00"
          : ""
        this.searchlist.endTime = this.searchlist.createDate[1]
          ? this.searchlist.createDate[1] + " 23:59:59"
          : ""
      } catch (error) {
        this.searchlist.startTime = ""
        this.searchlist.endTime = ""
      }

      let params = JSON.stringify({ ...this.searchlist, createDate: "" })
      var res = await request({
        url: "/admin/event/info/listEvent",
        method: "POST",
        data: params,
      })
      if (res.code == 200 && res.content != null) {
        // console.log( res.content)
        this.pageConfig.total = res.content.count
        this.tableData = res.content.list
        // if(res.content.list.length == 1){
        //     console.log(res.content.list[0].approvalStatus)
        //     this.activeName == res.content.list[0].approvalStatus
        // }
        if (res.content.count > 0) {
          //默认选中table状态
          this.$refs.singleTable.setCurrentRow(res.content.list[0])
        }
      } else {
        this.detail = {}
        this.detail.isShow = false
        this.$message({
          message: "数据加载异常：",
          type: "error",
        })
      }
      post("/admin/event/info/findEventTypeStatistics", {
        // orgId: this.$store.state.info.orgId,
        ...this.searchlist,
        createDate: "",
        approvalStatus: "",
      }).then((res) => {
        this.showData = res.content
          ? res.content
          : {
              ht: 0,
              ja: 0,
              yq: 0,
              zf: 0,
              zp: 0,
            }
      })
    },
    initMap() {
      // marker.set
      // if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
      //     marker.setPosition([this.mapMarker.lng, this.mapMarker.lat]);
      //     map.setFitView();
      // }
      map.remove(marker)
      if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
        marker = new AMap.Marker({
          position: [this.mapMarker.lng, this.mapMarker.lat], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: this.mapMarker.title,
          extData: {
            name: this.mapMarker.extDataName,
            desc: this.mapMarker.extDataDesc,
          },
          map: map,
        })
        map.setFitView(marker)
      } else {
        AMap.plugin("AMap.Geolocation", function () {
          //异步定位当前
          var geolocation = new AMap.Geolocation()
          map.addControl(geolocation)
        })
      }
      // 绑定事件
      marker.on("click", function (e) {
        if (!infoWindow) {
          infoWindow = new AMap.InfoWindow({ autoMove: true })
        }
        var extData = e.target.getExtData()
        // console.log(extData);
        infoWindow.setContent(
          "<div style='width: 230px;'>" +
            extData.name +
            "<br/>" +
            extData.desc +
            "</div>"
        )
        infoWindow.open(map, e.lnglat)
      })
    },
    handleClick(tab, event) {
      this.searchlist.approvalStatus = tab.paneName
      // if (tab.paneName == 4) {
      //     this.searchlist.supervise = 1;
      //     this.searchlist.eventCategory = "";
      // } else {

      //     this.searchlist.supervise = "";
      // }
      this.eventClickNum = 0
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //获取组织机构树
    async getOrgsTree() {
      this.selectOrgs = []
      var res = await request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: { threeType: 1,isValid: 1, },
      })
      //  console.log(res)
      if (res.content.length > 0) {
        res.content.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }
          this.selectOrgs.push({
            id: item.orgId,
            value: item.orgId,
            label: item.label,
            children: children,
          })
        })
      }
    },
    formateTree(arr) {
      var temp = []
      if (arr.length > 0) {
        arr.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }

          temp.push({
            value: item.orgId,
            label: item.label,
            children: children,
          })
        })
      }
      return temp
    },

    showDialog(row, flag) {
      this.funDialog.form.info = ""
      this.funDialog.form.off = "true"
      this.funDialog.form.eventNumber = row.eventNumber
      this.funDialog.form.info2 = ""
      this.funDialog.off = true
      this.funDialog.form.delayTime = null
      this.funDialog.title = "事件编号:" + row.eventNumber
      this.funDialog.type = flag
      switch (this.activeName) {
        case "1":
          this.funDialog.form = row
          this.funDialog.form.orgId = null
          this.funDialog.form.personId = ""
        case "7":
          this.funDialog.funName = "回退原因："
          // this.funDialog.form.approvalStatus = "7";
          this.permission = "sj:sjsl:htsh"
          this.funDialog.form.info2 = row.backReason
          this.funDialog.form.id = row.id
          break
        case "6":
          this.funDialog.funName = "延期原因："
          // this.funDialog.form.info = "edelayReason";
          this.permission = "sj:sjsl:yqsh"
          this.funDialog.form.info2 = row.delayReason
          this.funDialog.form.delayTime = row.delayTime
          this.funDialog.form.id = row.id
          break
        case "8":
          this.funDialog.funName = "作废原因："
          // this.funDialog.form.info = "ecancelReason";
          this.funDialog.form.info2 = row.cancelReason
          this.permission = "sj:sjsl:zfsh"
          this.funDialog.form.id = row.id
          break
        case "5":
          this.funDialog.funName = "结案原因："
          // this.funDialog.form.info = "ecompleteReason";
          this.funDialog.form.info2 = row.completeReason
          this.permission = "sj:sjsl:jash"
          this.funDialog.form.id = row.id
          break
        default:
          this.permission = "sj:sjsl:yqsj"
          break
      }
    },
    async funDialogClick() {
      console.log("这个？")
      let url = "/admin/event/info/updateEvent"
      let params = {}
      console.log("this.activeName", this.activeName)
      console.log("this.funDialog.form", this.funDialog.form)
      switch (this.activeName) {
        //事件指派
        case "1":
          let appstatus = "13"
          if (this.funDialog.form.personId != "") {
            appstatus = "4"
          }
          post("/admin/event/info/updateEvent", {
            ...this.funDialog.form,
            orgId: this.funDialog.form.orgId[
              this.funDialog.form.orgId.length - 1
            ],
            orgName: this.$refs.orgName.presentText,
            approvalStatus: appstatus,
            designeeId: this.$store.state.info.id,
            personName: this.$refs.personName.selectedLabel,
          }).then((res) => {
            this.$message({
              message: "转派成功",
              type: "success",
            })
            this.funDialog.off = false
            console.log(this.userOptions)
            console.log(this.funDialog.form.personId)
            let phone = this.userOptions.find(
              (item) => item.value == this.funDialog.form.personId
            )
            console.log(phone)
            post("/admin/complaints/info/sends", {
              linkPhone: phone.mobile,
              content: "网格内有事件需要处理",
            }).then((res) => {
              this.$message({
                message: "短信发送成功",
                type: "success",
              })
            })
            console.log(this.funDialog.form.phone)
            this.funDialog.off = false
            this.searchlist.approvalStatus = "1"
            this.getPageDatas()
          })
          return false
          break
        case "7":
          params.ebackReason = this.funDialog.form.info
          params.off = this.funDialog.form.off
          params.id = this.funDialog.form.id
          url = "/admin/event/info/returnExamine"
          break
        case "6":
          params.edelayReason = this.funDialog.form.info
          params.off = this.funDialog.form.off
          params.id = this.funDialog.form.id
          params.delayTime = this.funDialog.form.delayTime
          url = "/admin/event/info/delayExamine"
          break
        case "8":
          params.ecancelReason = this.funDialog.form.info
          params.off = this.funDialog.form.off
          params.id = this.funDialog.form.id
          url = "/admin/event/info/cancelExamine"
          break
        case "5":
          params.ecompleteReason = this.funDialog.form.info
          params.off = this.funDialog.form.off
          params.id = this.funDialog.form.id
          url = "/admin/event/info/completeExamine"
          break
        default:
          break
      }
      var res = await request({
        url: url,
        method: "POST",
        data: JSON.stringify(params),
      })
      if (res.code == 200) {
        this.funDialog.off = false
        this.getPageDatas()
        this.$message({
          message: "审核成功",
          type: "success",
        })
      } else {
        console.log(res)
        this.$message({
          message: "审核失败",
          type: "error",
        })
      }
    },
    clearaFunDialog() {
      this.funDialog.off = false
    },
    //获取人员
    getUser(value) {
      this.userOptions = []
      post("/admin/user/info/list", {
        orgId: this.funDialog.form.orgId[this.funDialog.form.orgId.length - 1],
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.list.forEach((e) => {
          this.userOptions.push({
            value: e.id,
            label: e.name,
            mobile: e.mobile,
          })
        })
      })
    },

    async eventNumberClick(rowVal) {
      if (!rowVal) {
        this.detail.eventFile1 = []
        this.detail.eventFile2 = []
        this.detail = {}
        this.mapMarker.lng = "117.49426"
        this.mapMarker.lat = "30.656587"
        this.mapMarker.extDataName = "无"
        this.mapMarker.extDataDesc = "无"
        this.$nextTick(() => {
          this.initMap()
        })
        return false
      }

      this.eventClickNum = this.eventClickNum + 1
      let params = JSON.stringify({ id: rowVal.id })
      var res = await request({
        url: "/admin/event/info/getEvent",
        method: "POST",
        data: params,
      })
      if (res.code == 200) {
        // console.log(res.content)
        this.detail = res.content
        this.detail.statusName = this.formatter(res.content.approvalStatus)
        //  var arr = res.content.enclosure.split(",");
        // this.detail.enclosure = [];
        this.detail.eventFile1 = []
        this.detail.eventFile2 = []
        res.content.eventFile.forEach((val) => {
          if (val.state == "1") {
            this.detail.eventFile1.push(val.url)
          } else {
            this.detail.eventFile2.push(val.url)
          }
        })

        //处理流程
        this.detail.logs = res.content.eventProcessList
        this.mapMarker.title = res.content.eventNumber
        if (res.content.longitude) {
          this.mapMarker.lng = res.content.longitude
          this.mapMarker.lat = res.content.latitude
        } else {
          this.mapMarker.lng = "117.49426"
          this.mapMarker.lat = "30.656587"
        }
        this.mapMarker.extDataName = res.content.eventDescribe
        this.mapMarker.extDataDesc = res.content.addressDetail
        this.$nextTick(() => {
          this.initMap()
        })
        if (this.eventClickNum > 1) {
          // document.getElementById("detailBox").scrollIntoView();
        }
      } else {
        this.$message({
          message: "获取数据异常",
          type: "error",
        })
      }
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length
      var totalselected = selected + fileList.length
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      )
    },
    uploadSuccess(response, file, fileList) {
      console.log(response)
      if (response.code == 200) {
        this.fileList_ += response.content.path + ","
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    formatter(row, column) {
      let statusName = ""
      this.statusMap.forEach((item) => {
        if (row.approvalStatus == item.value) {
          statusName = item.label
        }
      })
      return statusName
    },
  },
  mounted() {
    map = new AMap.Map("mapacc", {
      resizeEnable: true,
      zoom: 15,
      keyboardEnable: false,
      doubleClickZoom: false,
    })
    if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
      marker = new AMap.Marker({
        position: [this.mapMarker.lng, this.mapMarker.lat], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: this.mapMarker.title,
        extData: {
          name: this.mapMarker.extDataName,
          desc: this.mapMarker.extDataDesc,
        },
        map: map,
      })
      map.setFitView(marker)
    } else {
      AMap.plugin("AMap.Geolocation", function () {
        //异步定位当前
        var geolocation = new AMap.Geolocation()
        map.addControl(geolocation)
      })
    }
    // 绑定事件
    marker.on("click", function (e) {
      if (!infoWindow) {
        infoWindow = new AMap.InfoWindow({ autoMove: true })
      }
      var extData = e.target.getExtData()
      // console.log(extData);
      infoWindow.setContent(
        "<div style='width: 230px;'>" +
          extData.name +
          "<br/>" +
          extData.desc +
          "</div>"
      )
      infoWindow.open(map, e.lnglat)
    })
    this.statusMap = [
      { value: 1, label: "待批转" },
      // { value: 2, label: "撤销中" },
      // { value: 3, label: "已撤销" },
      { value: 4, label: "已接收" },
      { value: 5, label: "结案中" },
      { value: 6, label: "延期中" },
      { value: 7, label: "回退中" },
      { value: 8, label: "作废中" },
      { value: 9, label: "已回访" },
      { value: 10, label: "已作废" },
      { value: 11, label: "已虚拟" },
      { value: 12, label: "已虚拟" },
      { value: 13, label: "待领取" },
      { value: 14, label: "已结案" },
      { value: 15, label: "已延期" },
    ]

    this.sourceMap = [
      { value: "巡查上报", label: "巡查上报" },
      { value: "督查反馈", label: "督查反馈" },
      { value: "市长热线", label: "市长热线" },
      { value: "平台自建", label: "平台自建" },
      { value: "市民上报", label: "市民上报" },
      { value: "巡查反馈", label: "巡查反馈" },
      { value: "上级督查", label: "上级督查" },
    ]
    this.searchlist.approvalStatus = "1"
    this.getPageDatas()
    this.getOrgsTree()
    post("/rbac/admin/org/info/OrgTreelist", {
      orgType: "",isValid: 1,
    }).then((res) => {
      this.orgTree = res.content
    })
    // post("/admin/event/info/findEventTypeStatistics").then(res => {
    //     this.showData = res.content;
    // });
  },
}
</script>
<style lang="less" scoped>
.el-carousel {
  /deep/img {
    height: 100%;
    width: auto !important;
    margin: 0 auto !important;
    display: block;
  }
}
.card-box {
  float: left;
  width: 100%;
  min-height: calc(100vh - 120px);
}
.mapBox {
  float: left;
  margin-left: 10px;
  width: 300px !important;
  background-color: rgb(252, 249, 242);
  div {
    width: 300px;
    height: 100%;
  }
}
.listBox {
  float: left;
  width: calc(100% - 310px);
  display: flex;
  flex-direction: column;
}
.listBox-item {
  flex-grow: 1;
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
  overflow: hidden;
  .el-card {
    height: 100%;
  }
  .left-img {
    width: 90%;
    margin-top: 13px;
  }
  .el-timeline {
    height: 230px;
    overflow: auto;
  }
}
.detailInfo {
  font-size: 14px;
  line-height: 2;
}
.tabBtn {
  margin: 0;
}
.title-col {
  position: relative;
  .el-dropdown {
    position: absolute;
    top: 67px;
    right: 18px;
    z-index: 99;
  }
}
#detailBox {
  margin-bottom: 0px;
  flex-grow: 5;
}
</style>